import { NavbarOption } from 'modules/nav/types';
import { camelCase } from 'utils/stringHelpers';
import { NavigationMenuLink } from './NavigationMenuLink';
import { NavigationMenuLinks } from './NavigationMenuLinks';

type LinkContainerType = {
  dropdownOptions: NavbarOption[];
  path: string | undefined;
  shouldOpenInNewTab: boolean;
};

export const LinkContainer = ({ dropdownOptions, path, shouldOpenInNewTab }: LinkContainerType) => {
  return (
    <>
      {dropdownOptions?.map((option) => {
        return option?.linksSubsection ? (
          <NavigationMenuLinks key={camelCase(option.title)} option={option} />
        ) : (
          <NavigationMenuLink
            isActive={path === option.href}
            key={camelCase(option.title)}
            option={option}
            shouldOpenInNewTab={shouldOpenInNewTab}
          />
        );
      })}
    </>
  );
};
